import { valetAttendanceRequest } from "./action";
import { CREATE_SUPERVISOR,GET_PROJET,VALET_LIST, DELETE_SUPERVISOR, ALL_VALET_LIST_DATA, ALL_SUPERVISOR_LIST_DATA, UPDATE_SUPERVISOR_LIST_DATA, UPDATE_VALET_LIST_DATA, ATTENDANCE_REQUEST_LIST, GET_ALL_DAYS , VALET_ATTENDANCE_REQUEST, ALL_VALET_USERS} from "./type";

const initalState = {
    supervisorRes: null,
    supervisorList:null,
    valetList:null,
    deleteSupervisor: {},
    valetListData: {},
    supervisorListData: {},
    updateValetListData: {},
    updateSupervisorListData: {},
    getAttendanceRequests: {},
    getAllTheDaysData: {},
    valetAttendanceRequest: {},
    allValetUsers: {}
};

const CreateSupervisor = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_SUPERVISOR:
            return {
                ...state,
                supervisorRes: payload,
            };
        case GET_PROJET:
            return {
                ...state,
                supervisorList: payload,
            };
        case VALET_LIST:
            return {
                ...state,
                valetList: payload,
            };
        case DELETE_SUPERVISOR:
            return {
                ...state,
                deleteSupervisor: payload,
            };
        case ALL_VALET_LIST_DATA:
            return {
                ...state,
                valetListData: payload,
            };
        case ALL_SUPERVISOR_LIST_DATA:
            return {
                ...state,
                supervisorListData: payload,
            };
        case UPDATE_SUPERVISOR_LIST_DATA:
            return {
                ...state,
                updateValetListData: payload,
            };
        case UPDATE_VALET_LIST_DATA:
            return {
                ...state,
                updateSupervisorListData: payload,
            };
        case ATTENDANCE_REQUEST_LIST:
            return {
                ...state,
                getAttendanceRequests: payload,
            };
        case GET_ALL_DAYS:
            return {
                ...state,
                getAllTheDaysData: payload,
            };
        case VALET_ATTENDANCE_REQUEST:
            return {
                ...state,
                valetAttendanceRequest: payload,
            };
        case ALL_VALET_USERS:
            return {
                ...state,
                allValetUsers: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CreateSupervisor;
